export class User {
    userId:number;
    name:string;
    username:string;
    password:string
    errorMessage = 'Invalid Credentials';
    successMessage: any;
    invalidLogin = false;
    loginSuccess = false;
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    role?: string;


constructor( ){ }
}